class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      if (this.shouldWaitForCollectionApply(event)) return;

      this.debouncedOnSubmit(event);
    });
    facetForm.addEventListener('click', (event) => {
      const applyButton = event.target.closest('[data-collection-facets-apply]');
      if (!applyButton || !facetForm.contains(applyButton)) return;

      FacetFiltersForm.scrollToCollectionGridAfterRender = true;
      this.onSubmitHandler(event);
    });
    FacetFiltersForm.initEnhancedPriceRanges(this);

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  shouldWaitForCollectionApply(event) {
    const mobileForm = event.target.closest('form#FacetFiltersFormMobile');
    return Boolean(
      document.body.classList.contains('template-collection') &&
        mobileForm &&
        mobileForm.closest('.collection-facets-drawer-trigger')
    );
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (FacetFiltersForm.scrollToCollectionGridAfterRender) {
      FacetFiltersForm.scrollToCollectionGridAfterRender = false;
      FacetFiltersForm.scrollToCollectionGridStart();
    }
  }

  static scrollToCollectionGridStart() {
    const target = document.getElementById('main-collection-filters') || document.getElementById('ProductGridContainer');
    if (!target) return;

    const header =
      document.querySelector('sticky-header') ||
      document.querySelector('.shopify-section-header-sticky') ||
      document.getElementById('shopify-section-header') ||
      document.querySelector('.section-header');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight - 8;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth',
    });
  }

  static initEnhancedPriceRanges(root = document) {
    root.querySelectorAll('[data-price-range-enhanced]:not([data-price-range-ready])').forEach((range) => {
      range.setAttribute('data-price-range-ready', 'true');

      const priceRange = range.closest('price-range');
      if (!priceRange) return;

      const minRange = range.querySelector('[data-price-range-min]');
      const maxRange = range.querySelector('[data-price-range-max]');
      const minInput = priceRange.querySelector('.field__input[name*=".gte"]');
      const maxInput = priceRange.querySelector('.field__input[name*=".lte"]');
      const minLabel = priceRange.querySelector('[data-price-range-min-label]');
      const maxLabel = priceRange.querySelector('[data-price-range-max-label]');
      const currencySymbol = range.dataset.currencySymbol || '';

      const parseMoneyToCents = (value) => {
        const rawValue = String(value || '').replace(/[^\d,.-]/g, '');
        if (!rawValue) return null;

        const normalized = rawValue.includes(',')
          ? rawValue.replace(/\./g, '').replace(',', '.')
          : rawValue;
        const numberValue = Number(normalized);

        return Number.isFinite(numberValue) ? Math.round(numberValue * 100) : null;
      };
      const maxCents = parseMoneyToCents(range.dataset.rangeMax) || parseMoneyToCents(maxInput.dataset.max);

      if (!minRange || !maxRange || !minInput || !maxInput || !minLabel || !maxLabel || !maxCents) return;

      const visualMax = 1000;
      const firstBreak = Math.min(50000, maxCents);
      const secondBreak = Math.min(100000, maxCents);
      const firstVisualEnd = 700;
      const secondVisualEnd = 900;

      minRange.max = visualMax;
      maxRange.max = visualMax;
      minRange.step = 1;
      maxRange.step = 1;
      const formatMoney = (cents) =>
        (Math.round(cents) / 100).toLocaleString('es-ES', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
      const displayMoney = (cents) => `${formatMoney(cents)}${currencySymbol}`;
      const priceToVisual = (cents) => {
        const clampedCents = Math.min(Math.max(cents, 0), maxCents);

        if (maxCents <= 50000) return (clampedCents / maxCents) * visualMax;
        if (clampedCents <= firstBreak) return (clampedCents / firstBreak) * firstVisualEnd;
        if (maxCents <= 100000) {
          return firstVisualEnd + ((clampedCents - firstBreak) / (maxCents - firstBreak)) * (visualMax - firstVisualEnd);
        }
        if (clampedCents <= secondBreak) {
          return firstVisualEnd + ((clampedCents - firstBreak) / (secondBreak - firstBreak)) * (secondVisualEnd - firstVisualEnd);
        }

        return secondVisualEnd + ((clampedCents - secondBreak) / (maxCents - secondBreak)) * (visualMax - secondVisualEnd);
      };
      const visualToPrice = (visualValue) => {
        const clampedVisual = Math.min(Math.max(visualValue, 0), visualMax);

        if (maxCents <= 50000) return Math.round((clampedVisual / visualMax) * maxCents);
        if (clampedVisual <= firstVisualEnd) return Math.round((clampedVisual / firstVisualEnd) * firstBreak);
        if (maxCents <= 100000) {
          return Math.round(firstBreak + ((clampedVisual - firstVisualEnd) / (visualMax - firstVisualEnd)) * (maxCents - firstBreak));
        }
        if (clampedVisual <= secondVisualEnd) {
          return Math.round(firstBreak + ((clampedVisual - firstVisualEnd) / (secondVisualEnd - firstVisualEnd)) * (secondBreak - firstBreak));
        }

        return Math.round(secondBreak + ((clampedVisual - secondVisualEnd) / (visualMax - secondVisualEnd)) * (maxCents - secondBreak));
      };
      const updateNativeInput = (input, cents, isMax) => {
        if ((!isMax && cents <= 0) || (isMax && cents >= maxCents)) {
          input.value = '';
          return;
        }

        input.value = formatMoney(cents);
      };
      const updateRangeFill = (minVisual, maxVisual) => {
        const minPercent = (minVisual / visualMax) * 100;
        const maxPercent = (maxVisual / visualMax) * 100;

        range.style.setProperty('--price-range-min', `${minPercent}%`);
        range.style.setProperty('--price-range-max', `${maxPercent}%`);
      };
      const syncFromSliders = () => {
        let minVisual = Number(minRange.value);
        let maxVisual = Number(maxRange.value);

        if (minVisual > maxVisual) {
          if (document.activeElement === minRange) {
            maxVisual = minVisual;
            maxRange.value = maxVisual;
          } else {
            minVisual = maxVisual;
            minRange.value = minVisual;
          }
        }

        const minValue = visualToPrice(minVisual);
        const maxValue = visualToPrice(maxVisual);

        updateNativeInput(minInput, minValue, false);
        updateNativeInput(maxInput, maxValue, true);
        minInput.placeholder = formatMoney(0);
        maxInput.placeholder = formatMoney(maxCents);
        minLabel.textContent = displayMoney(minValue);
        maxLabel.textContent = displayMoney(maxValue);
        updateRangeFill(minVisual, maxVisual);
      };
      const syncFromFields = () => {
        const minValue = parseMoneyToCents(minInput.value);
        const maxValue = parseMoneyToCents(maxInput.value);

        minRange.value = minValue === null ? 0 : priceToVisual(minValue);
        maxRange.value = maxValue === null ? visualMax : priceToVisual(maxValue);
      };

      minRange.addEventListener('input', syncFromSliders);
      maxRange.addEventListener('input', syncFromSliders);
      minInput.addEventListener('input', syncFromFields);
      maxInput.addEventListener('input', syncFromFields);

      syncFromFields();
      syncFromSliders();
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const shouldReplaceAllFilters = Boolean(event?.target.closest('facet-remove'));
    const matchesId = (element) => {
      if (shouldReplaceAllFilters) return false;

      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.initEnhancedPriceRanges(document);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const currentPillsForm = document.querySelector('facet-filters-form.facets-pill');
    const newPillsForm = html.querySelector('facet-filters-form.facets-pill');

    if (newPillsForm && currentPillsForm) {
      currentPillsForm.outerHTML = newPillsForm.outerHTML;
    } else if (newPillsForm && !currentPillsForm) {
      document.querySelector('.collection-facets-product-count')?.after(newPillsForm);
    } else if (!newPillsForm && currentPillsForm) {
      currentPillsForm.remove();
    }

    const currentMobileFacets = document.querySelector('.active-facets-mobile');
    const newMobileFacets = html.querySelector('.active-facets-mobile');

    if (newMobileFacets && currentMobileFacets) {
      currentMobileFacets.outerHTML = newMobileFacets.outerHTML;
    } else if (newMobileFacets && !currentMobileFacets) {
      document.querySelector('.mobile-facets__wrapper')?.after(newMobileFacets);
    } else if (!newMobileFacets && currentMobileFacets) {
      currentMobileFacets.remove();
    }

    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const currentFacetsElement = document.querySelector(selector);
      if (!currentFacetsElement || !activeFacetsElement) return;
      currentFacetsElement.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.scrollToCollectionGridAfterRender = false;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input.field__input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input.field__input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
